import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { GenericDialogComponent, DialogContentData } from 'src/app/shared/generic-dialog/generic-dialog.component';

@Component({
  selector: 'app-forgot-password-dialog',
  templateUrl: './forgot-password-dialog.component.html',
  styleUrls: ['./forgot-password-dialog.component.css']
})

export class ForgotPasswordDialogComponent implements OnInit {
  forgotPassForm: FormGroup

  constructor(
    private formBuilder:FormBuilder,
    public dialogRef: MatDialogRef<GenericDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogContentData
  ) {}

  ngOnInit(): void {
    this.forgotPassForm = this.formBuilder.group({
      email: [, [Validators.required, Validators.email]],
    })

  }

  onConfirm() {
    this.data.positiveCallback(this.forgotPassForm.value.email)
    this.dialogRef.close(this.forgotPassForm.value.email)
  }

  onCancle(){
    this.dialogRef.close()
    this.data.cancleCallback()
  }

}